import axiosInstance from "./axiosInstance";

const apiPath = process.env.REACT_APP_API_HOST;

const get = async (url, params, useBaseApiPath, otherConfig, noToken) => {
  return _makeRequest(
    "GET",
    url,
    params,
    null,
    useBaseApiPath,
    otherConfig,
    {},
    noToken
  );
};
const post = async (
  url,
  params,
  data,
  useBaseApiPath,
  otherConfig,
  otherHeaders,
  noToken
) => {
  return _makeRequest(
    "POST",
    url,
    params,
    data,
    useBaseApiPath,
    otherConfig,
    otherHeaders
  );
};

const put = async (url, params, data, useBaseApiPath, otherConfig) => {
  return _makeRequest("PUT", url, params, data, useBaseApiPath, otherConfig);
};

const patch = async (url, params, data, useBaseApiPath, otherConfig) => {
  return _makeRequest("PATCH", url, params, data, useBaseApiPath, otherConfig);
};

const remove = async (url, params, data, useBaseApiPath, noToken) => {
  return _makeRequest(
    "DELETE",
    url,
    params,
    data,
    useBaseApiPath,
    {},
    {},
    noToken
  );
};

const _makeRequest = async (
  type,
  url,
  params,
  data,
  useBaseApiPath = true,
  otherConfig = {},
  otherHeaders = {},
  noToken = false,
  returnResObj = false
) => {
  const requestType = type ? type.toUpperCase() : "GET";

  const extraConfig = otherConfig ? otherConfig : {};

  const apiUrl = useBaseApiPath ? apiPath + url : url;

  let config = {
    url: apiUrl,
    params,
    method: requestType,
    ...extraConfig,
  };

  if (requestType !== "GET") {
    config.data = data;
  }

  let requestHeaders = {};

  const token = sessionStorage.getItem("token");

  if (token && !noToken) {
    requestHeaders.authorization = `Bearer ${token}`;
  }

  config["headers"] = {
    ...requestHeaders,
    ...otherHeaders,
  };

  return new Promise((resolve, reject) => {
    axiosInstance(config)
      .then((response) => {
        if (config.responseType === "blob") resolve(response);
        else resolve(returnResObj ? response : response.data);
      })
      .catch((error) => {
        if (error && error.response) {
          const status = error.response.status;
          const errCode =
            error.response.data && error.response.data.error
              ? error.response.data.error.code
              : "";
          if (status === 401 || status === 422) {
            _signOutUser();
          }
          if (status === 404 && errCode === "BE-304") {
            _signOutUser();
          }
        }
        reject(error);
      });
  });
};

const _signOutUser = () => {
  const role = sessionStorage.getItem("userRole");
  const phone = sessionStorage.getItem("phone");

  localStorage.clear();
  if (role === "user") {
    window.location.href = `/user/${phone}/login`;
  } else {
    sessionStorage.clear();
    window.location.href = "/login";
  }
};

const BaseApiService = {
  get,
  post,
  put,
  patch,
  delete: remove,
  request: _makeRequest,
};

export default BaseApiService;
